<template>
  <article>
    <div class="filter mt-20 mb-20">
      <div class="filter__item">
        <div class="filter__name">广告名：</div>
        <el-input v-model="filters.title" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">广告ID：</div>
        <el-input v-model="filters.adid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">状态：</div>
        <el-select class="filter__input" size="mini" v-model="filters.status">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in statusList" :key="index"></el-option>
        </el-select>
      </div>
      <button class="blue-small-btn" @click="getList">搜索</button>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="600">
      <el-table-column prop="adid" label="广告ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="title" label="广告名" width="" align="center">
      </el-table-column>
      <el-table-column prop="" label="上家折扣" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.aver_discount}}%</div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="底价折扣" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.min_discount}}%</div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="用户折扣" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.discount}}%</div>
        </template>
      </el-table-column>
      <el-table-column prop="cashback_cycle" label="返现周期" width="" align="center">
      </el-table-column>
      <el-table-column prop="quota" label="总额度" width="" align="center">
      </el-table-column>
      <el-table-column label="总数据（排除丢单）">
        <el-table-column prop="ocount" label="订单数" width="" align="center">
        </el-table-column>
        <el-table-column prop="payment" label="金额" width="" align="center">
        </el-table-column>
        <el-table-column prop="income" label="收入" width="" align="center">
        </el-table-column>
        <el-table-column prop="commission" label="佣金" width="" align="center">
        </el-table-column>
        <el-table-column prop="profit" label="利润" width="" align="center">
        </el-table-column>
        <el-table-column prop="apply" label="请款" width="" align="center">
        </el-table-column>
        <el-table-column prop="receive" label="收款" width="" align="center">
        </el-table-column>
      </el-table-column>
      <el-table-column label="进行中">
        <el-table-column prop="running_ocount" label="订单数" width="" align="center">
        </el-table-column>
        <el-table-column prop="running_payment" label="金额" width="" align="center">
        </el-table-column>
        <el-table-column prop="running_commission" label="佣金" width="" align="center">
        </el-table-column>
      </el-table-column>
      <el-table-column label="丢单">
        <el-table-column prop="invalid_ocount" label="订单数" width="" align="center">
        </el-table-column>
        <el-table-column prop="invalid_payment" label="金额" width="" align="center">
        </el-table-column>
        <el-table-column prop="invalid_commission" label="佣金" width="" align="center">
        </el-table-column>
      </el-table-column>
      <el-table-column label="提现">
        <el-table-column prop="apply_ocount" label="订单数" width="" align="center">
        </el-table-column>
        <el-table-column prop="apply_payment" label="金额" width="" align="center">
        </el-table-column>
        <el-table-column prop="apply_income" label="收入" width="" align="center">
        </el-table-column>
        <el-table-column prop="apply_commission" label="佣金" width="" align="center">
        </el-table-column>
      </el-table-column>
      <el-table-column prop="" label="创建时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="状态" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 1" class="normal-btn">运行</div>
          <div v-if="scope.row.status == 0" class="danger-btn">下架</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
  </article>
</template>

<script>
import util from '../../script/util'
import mixinList from '../../mixins/list'
import {adLists} from '../../api/api'
export default {
  name: 'adList',
  mixins: [mixinList],
  data () {
    return {
      statusList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '运行',
          value: 1
        },
        {
          name: '下架',
          value: 0
        }
      ],
      lists: [],
      listLoading: false,
      filters: {
        p: 1,
        l: 20,
        total: 0,
        adid: '',
        title: '',
        status: ''
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }

      if (filters.adid !== '') {
        params.adid = filters.adid
      }

      if (filters.title !== '') {
        params.title = filters.title
      }

      if (filters.status !== '') {
        params.status = filters.status
      }

      this.listLoading = true
      adLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.notifyError('服务器出错了')
      })
    },
    filterParamsChange () {
      this.filters.p = 1
      this.getList()
    }
  },
  watch: {
    'filters.adid': 'filterParamsChange',
    'filters.title': 'filterParamsChange',
    'filters.status': 'filterParamsChange'
  },
  mounted () {
    this.getList()
    util.setCookie('createAddetail', '')
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/data/adData.vue